/** Checkbox primitive (Radix). */
import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '@/lib/utils';

/** Styled Radix checkbox with checked / indeterminate icons. */
const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'modern-checkbox ripple-effect peer',
      'focus-visible:ring-[var(--color-2-nuance-1)]/50',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="modern-checkbox-indicator">
      {props.checked === 'indeterminate' ? (
        <Minus className="modern-checkbox-icon" />
      ) : (
        <Check className="modern-checkbox-icon" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
